import { createGenericDispatcher } from '../../../action/action-dispatcher-factory';
import { announcementsForEmployeeGroupIdStateSelector } from '../../../employee-groups/employee-group-selectors';

import * as Api from '../../../api/api';

export const loadEmployeeGroupAnnouncements = (orgId: number, employeeGroupId: number | string) =>
  createGenericDispatcher({
    name: 'LOAD_EMPLOYEE_GROUP_ANNOUNCEMENTS',
    loadFunction: () => Api.get(`/employee-groups/${employeeGroupId}/announcements?orgId=${orgId}`),
    args: { orgId, employeeGroupId },
    shouldExecuteSelector: (state: any) =>
      announcementsForEmployeeGroupIdStateSelector(state, employeeGroupId),
  });
